export default "__VITE_ASSET__00ea5401__"